// extracted by mini-css-extract-plugin
export default {"container":"OrangeTabs_container__y71ds","tab":"OrangeTabs_tab__mvyQd","active":"OrangeTabs_active__N1dMR"};